var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoParticipantrecruit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 15.502C12.0301 15.5021 15.4999 18.9719 15.5 23.252C15.5 27.5321 12.0301 31.0018 7.75 31.002C3.46976 31.002 0 27.5322 0 23.252C6.82927e-05 18.9718 3.46981 15.502 7.75 15.502ZM23.25 15.502C27.5302 15.502 30.9999 18.9718 31 23.252C31 27.5322 27.5302 31.0019 23.25 31.002C18.9698 31.002 15.5 27.5322 15.5 23.252C15.5001 18.9718 18.9698 15.502 23.25 15.502ZM7.75 0C12.0302 0 15.5 3.4698 15.5 7.75C15.5 12.0302 12.0302 15.5 7.75 15.5C3.46979 15.5 0 12.0302 0 7.75C4.51597e-05 3.46982 3.46982 2.86054e-05 7.75 0ZM23.25 0C27.5302 3.73657e-05 30.9999 3.46986 31 7.75C31 12.0302 27.5302 15.5 23.25 15.5C18.9698 15.5 15.5 12.0302 15.5 7.75C15.5001 3.46983 18.9698 0 23.25 0Z",
    fill: "#F69C1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoParticipantrecruit);
export default __webpack_public_path__ + "static/media/Ico_Participant recruit.f801286ffe85c1d54553b4a12fb8f596.svg";
export { ForwardRef as ReactComponent };